import { OverflowTooltip } from '@/components/ui/OverflowTooltip';
import type { PickListOption } from '@/lib/api/types/picklistOption';

export const MultiPickListCell = ({ value }: { value?: PickListOption[] }) =>
  Boolean(value?.length) && (
    <OverflowTooltip>{value?.map((option) => option.name).join(', ')}</OverflowTooltip>
  );
